import ProfileComp from "../admin/admincomponent/Profile/ProfileComp";
import SchemeDetails from "../jsx/components/Scheme/SchemeDetails";
import SchemeForm from "../jsx/components/Scheme/SchemeForm";
import SubmittedSchemeForm from "../jsx/components/Scheme/SubmittedSchemeForm";
import DeleteUserAccount from "../jsx/components/Users/DeleteUserAccount";
import UserNotification from "../jsx/components/Users/UserNotification";
import UserSchemes from "../jsx/components/Users/UserSchemes";
import UserTicket from "../jsx/components/Users/UserTicket";
import { ApplyForDiscount } from "../jsx/components/Users/ApplyForDiscount";
import Certificate from "../jsx/components/Users/Certificate";
import Accreditation from "../jsx/components/Users/Accreditation";


import Index from "../admin/admincomponent/BatchManagement/Batches/Index";
import Calendar from "../admin/admincomponent/BatchManagement/Calendar/Index";
import CreateBatch from "../admin/admincomponent/BatchManagement/Batches/CreateBatch";
import ViewBatch from "../admin/admincomponent/BatchManagement/Batches/ViewBatch";
import CreateTraining from "../admin/admincomponent/BatchManagement/Calendar/CreateTraining";
import AcademyDashboard from "../admin/admincomponent/BatchManagement/Dashboard/index";
import AttendanceReport from "../admin/admincomponent/BatchManagement/Attendance/Index";


// // FIXED MISSING IMPORTS HERE
import EditProfileRequest from "../jsx/components/Users/EditProfileRequest";
import PublicGrievance from "../jsx/components/Users/PublicGrievance";
import RegistrationList from "../admin/admincomponent/registration/RegistrationList";
// import AssessmentReportsPage from "../jsx/components/Users/AssessmentReportsPage";
// import EditProfileHistory from "../admin/admincomponent/editProfile/EditProfileHistory";

export const allUserroutes = [
  { url: "registration", component: <RegistrationList /> },
  { url: "profile", component: <ProfileComp /> },
  { url: "Certificate", component: <Certificate /> },
  { url: "Accreditation", component: <Accreditation /> },
  { url: "user-grievance-management", component: <UserTicket /> },
  { url: "apply-for-discount", component: <ApplyForDiscount /> },
  { url: "notification", component: <UserNotification /> },
  { url: "grant-scheme", component: <UserSchemes /> },
  { url: "grant-scheme/description/:encryptedSchemeId", component: <SchemeDetails /> },
  { url: "grant-scheme/form/:encryptedSchemeId", component: <SchemeForm /> },
  { url: "grant-scheme/submitted-form/:encryptedFormId", component: <SubmittedSchemeForm /> },
  { url: "user/delete-account", component: <DeleteUserAccount /> },
  { url: "edit-profile", component: <EditProfileRequest /> },
  {
    url: "batch-management/batches",
    component: <Index/>,
  },
  {
    url: "batch-management/batches/add",
    component: <CreateBatch />,
  },
  {
    url: "batch-management/batches/viewBatch/:id",
    component: <ViewBatch />
  },
  {
    url: "batch-management/batches/update/:id",
    component: < CreateBatch />,
  },
  {
    url: "batch-management/calendar",
    component: <Calendar />,
  },
  {
    url: "batch-management/calendar/create-training",
    component: <CreateTraining />,
  },
  {
    url: "batch-management/calendar/update/:id",
    component: <CreateTraining />,

  },
  {
    url: "batch-management/dashboard",
    component: <AcademyDashboard />,
  },
  {
    url: "batch-management/attendance-report",
    component: <AttendanceReport />,
  },
  //Comment for mock merging in staging environment
  // { url: "assessment-reports", component: <AssessmentReportsPage /> },
  // { url: "edit-profile-history", component: <EditProfileHistory /> }
];